export default {
  name: 'HeaderBanner',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  computed: {},
  methods: {
    onClickBanner() {
      window.gtag('event', 'sale_banner_click', {
        banner_name: 'black_friday_2025',
        banner_position: 'homepage_top'
      });

      // window.dataLayer = window.dataLayer || [];
      // window.dataLayer.push({
      //   event: 'sale_banner_click',
      //   banner_name: 'black_friday_2025',
      //   banner_position: 'homepage_top'
      // });
      console.log('window', window);

      this.$router.push({ name: 'selection' }).catch(() => {});
    }
  }
};
